import React, { useEffect } from 'react';
import { Line, Pie, Bar, Column } from '@ant-design/charts';
import './index.less';

const PageModel = props => {
	const data = [
		{
			type: '运行中...',
			value: 27,
		},
		{
			type: '故障',
			value: 5,
		},
	];
	const config = {
		radius: 0.8,
		data,
		angleField: 'value',
		colorField: 'type',
		label: {
			visible: true,
			type: 'spider',
		},
	};
	useEffect(() => {

	}, [123]);

	return (
		<Pie {...config} />
	);
};

export default PageModel;
